import React, { Component } from "react";
import Post from "../../services/post";
import MetaDecorator from "../../services/MetaDecorator";
import blog from "../../../media/images/blog.jpg";
import blogMobile from "../../../media/images/blogMobile.jpg";

export class Blog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      variablesSet: false,
      title: "",
      siteTitle: "",
      siteDescription: "",
      url: "",
    };
  }

  componentDidMount = () => {
    let tabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[0]
      .querySelectorAll("a");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].removeAttribute("class");

      if (tabs[i].id === "blog") {
        tabs[i].setAttribute("class", "orange-text text-darken-4");
      }
    }

    let mobileTabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[2]
      .querySelectorAll("a");
    for (let i = 0; i < mobileTabs.length; i++) {
      if (mobileTabs[i].id === "blogMobile") {
        mobileTabs[i].removeAttribute("class");
        mobileTabs[i].setAttribute(
          "class",
          "orange-text text-darken-4 grey darken-3"
        );
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  setVariables = (variables) => {
    if (!this.state.variablesSet) {
      this.setState({
        title: variables.blogTitle,
        siteTitle: variables.siteTitle,
        siteDescription: variables.siteDescription,
        url: variables.url,
        variablesSet: true,
      });
    }
  };

  render() {
    const { width, title, siteTitle, siteDescription, url } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MetaDecorator
          title={siteTitle}
          descrption={siteDescription}
          url={`${url}/`}
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blogMobile}
              alt="JetMinds Blog"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blog}
              alt="JetMinds Blog"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                {title}
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">{title}</h1>
            </div>
          )}
        </div>
        <Post
          isTablet={isTablet}
          isMobile={isMobile}
          path={window.location.pathname}
          setVariables={this.setVariables}
        />
      </React.Fragment>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/components/layout/pages/BlogItem.js